import '@material-design-icons/font';
import { GlobalStyles } from '@mui/material';
import { ConfirmationProvider } from '@app/global/providers/ConfirmationProvider/ConfirmationProvider';
import { InternationalizationProvider } from '@app/internationalization/providers/InternationalizationProvider';
import { AppSkeleton } from '@components/common/app-skeleton/AppSkeleton';
import { SnackbarProvider } from 'notistack';
import { lazy, Suspense } from 'react';
import '@static/styles/theme/fonts.css';
import { globalStyling } from '@static/styles/theme/globalStyling ';
import { ApolloWrapper } from './app/global/providers/ApolloProvider/ApolloWrapper';
import { useAuth0 } from '@auth0/auth0-react';

const AuthenticatedApp = lazy(() => import('@components/app/authenticated-app/AuthenticatedApp.tsx'));
const UnauthenticatedApp = lazy(() => import('@components/app/UnauthenticatedApp.tsx'));

function App() {
  const { isAuthenticated, isLoading } = useAuth0();
  if (isLoading) {
    return <AppSkeleton primaryCount={6} secondaryCount={1} topbarCount={3} itemSize={36} />;
  }

  return (
    <InternationalizationProvider>
      <Suspense fallback={<AppSkeleton primaryCount={6} secondaryCount={1} topbarCount={3} itemSize={36} />}>
        {isAuthenticated ? (
          <ConfirmationProvider>
            <ApolloWrapper>
              <SnackbarProvider
                maxSnack={10}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                preventDuplicate={true}
              >
                <GlobalStyles styles={globalStyling} />
                <AuthenticatedApp />
              </SnackbarProvider>
            </ApolloWrapper>
          </ConfirmationProvider>
        ) : (
          <UnauthenticatedApp />
        )}
      </Suspense>
    </InternationalizationProvider>
  );
}

export default App;
